import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-[#0a0e17] overflow-hidden flex items-center justify-center py-8 sm:py-14 px-4 sm:px-6 lg:px-8" data-id="element-52">
      {/* Background Effects */}
      <div className="absolute inset-0 z-0" data-id="element-53">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#1e6bb8]/20 rounded-full blur-[100px]" data-id="element-54" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#d4a853]/10 rounded-full blur-[100px]" data-id="element-55" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" data-id="element-56" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto" data-id="element-57">
        {/* Centered Headline */}
        <motion.div initial={{
        opacity: 0,
        y: -30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-6 sm:mb-10 space-y-2 sm:space-y-3" data-id="element-58">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.1] tracking-tight" data-id="element-59">
            Creá tu primera{' '}
            <span className="text-[#d4a853] italic" data-id="element-60">
              pieza profesional en resina
            </span>
            <br data-id="element-61" />
            <span className="text-[#f5f0e8]" data-id="element-62">en solo</span>{' '}
            <span className="text-[#d4a853]" data-id="element-63">7 días</span>
          </h1>
          <p className="text-lg sm:text-xl text-[#9ca3af] font-medium italic max-w-2xl mx-auto" data-id="element-64">
            (sin taller profesional, sin herramientas costosas, sin experiencia
            previa)
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-65">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-left space-y-5 sm:space-y-8" data-id="element-66">
            <p className="text-base md:text-xl text-[#f5f0e8]/90 leading-relaxed max-w-2xl border-l-4 border-[#1e6bb8] pl-4 sm:pl-6" data-id="element-67">
              El único ebook en español diseñado para que abras, sigas los pasos
              y crees — sin vueltas.
            </p>

            <div className="pt-2 sm:pt-4" data-id="element-68">
              <a href="#precio" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-[#0a0e17] transition-all duration-200 bg-[#d4a853] rounded-lg hover:bg-[#f59e0b] hover:shadow-[0_0_20px_rgba(212,168,83,0.5)] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#d4a853] focus:ring-offset-[#0a0e17]" data-id="element-69">
                <span data-id="element-70">QUIERO MI MÁSTER AHORA</span>
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-71" />
                <div className="absolute inset-0 rounded-lg ring-2 ring-white/20 group-hover:ring-white/40 transition-all" data-id="element-72" />
              </a>
            </div>
            <p className="mt-4 text-sm text-[#9ca3af] flex items-center gap-2" data-id="element-73">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-74" />
              Oferta disponible para Uruguay
            </p>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative mx-auto lg:mx-0" data-id="element-75">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-[#1e6bb8]/20 border border-[#ffffff]/10 group" data-id="element-76">
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e17] via-transparent to-transparent opacity-60 z-10" data-id="element-77" />
              <img src="https://cdn.magicpatterns.com/uploads/iaASZCvp3GDtBLvFvD1Eaf/Libro_Digital.jpg" alt="Máster Visual en Resina Epoxi Ebook" className="w-full max-w-md lg:max-w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-78" />

              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 z-20 bg-[#0a0e17]/90 backdrop-blur-md border border-[#d4a853]/30 p-4 rounded-xl shadow-lg" data-id="element-79">
                <p className="text-[#d4a853] font-bold text-sm uppercase tracking-wider mb-1" data-id="element-80">
                  🎁 Incluye
                </p>
                <p className="text-white font-medium text-xs" data-id="element-81">
                  4 Bonos de Regalo Exclusivos
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}